import React from 'react';
import TablePage, {
  TableConfig,
  TableFilter,
  TableHead,
} from '../../../components/table/TablePage';
import { apiDownloadsGet, apiDownloadsGetEmails } from '../../../actions/downloadActions';
import { useSelector } from 'react-redux';
import PageNotFound from '../../pagenotfound/PageNotFound';

const configHeads: TableHead[] = [
  {
    name: '',
    width: '20px',
    key: 'empty',
  },
  {
    name: 'Type',
    width: null,
    key: 'type',
    type: 'string',
  },
  {
    name: 'Email',
    width: null,
    key: 'email',
    type: 'string',
  },
  {
    name: 'Video ID',
    width: null,
    key: 'video_id',
    type: 'string',
  },
  {
    name: 'Album ID',
    width: null,
    key: 'album_id',
    type: 'string',
  },
  {
    name: 'Downloaded at',
    width: '160px',
    key: 'created_at',
    type: 'date',
    options: {
      format: 'DD/MM/YYYY HH:mm:ss',
    },
  },
];

const configFilters: TableFilter[] = [
  {
    id: 'Email',
    type: 'select',
    label: 'Email',
    options: {
      label: 'Please select email',
      secured: true,
      onLoadElements: apiDownloadsGetEmails,
    },
  },
  {
    id: 'Downloaded At',
    type: 'date',
    label: 'Downloaded At',
  },
  {
    id: 'Type',
    type: 'select',
    label: 'Type',
    options: {
      label: 'Please select type',
      elements: ['Photo', 'Video'],
    },
  },
];

const config: TableConfig = {
  title: 'Downloads',
  key: 'downloads',
  functions: {
    loadElementsMethod: apiDownloadsGet,
    convertElementsMethod: (elements: any[]) => [
      ...elements.map(element => {
        return {
          ...element,
          id: element.video ? element.video.id : null,
          email: element.user ? element.user.email : null,
          type: element.album ? 'Photo' : 'Video',
        };
      }),
    ],
  },
  options: {
    hasSwitcher: false,
    hasSearch: false,
  },
  heads: configHeads,
  filters: configFilters,
};

function PanelDownloads() {
  const user = useSelector(state => state.user);

  if (user.user && parseInt(user.user.admin) === 0) {
    return <PageNotFound />;
  }

  return <TablePage config={config} />;
}

export default PanelDownloads;
